import React, { useState, useEffect, useContext } from "react";
import { Modal, Button, Form, Col, Row } from "react-bootstrap";
import Prev_Btn from "../common/common-btn/prev-btn/Prev_Btn";
import Next_Btn from "../common/common-btn/next-btn/Next_Btn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useForm } from "react-hook-form";
import { Context } from "../../utils/context";

const Edit_Name_Modal = ({ show, handleClose, getBooking, handleUpdate }) => {

  const handleSave = () => {
    handleClose();
  };


  const {
    register,
    handleSubmit,
    control, reset,
    formState: { errors },
  } = useForm();

  const {
    IMG_URL,
    Select2Data,
    getData,
    postData,
    BookingData,
    setBookingData
  } = useContext(Context);

  const onSubmit = async (data) => {
    console.log("Form Data:", data);
    const formData = new FormData();

    formData.append("contact_no", data?.contact_no);
    formData.append("email", data?.email);
    formData.append("first_name", data?.first_name);
    formData.append("last_name", data?.last_name);

    const response = await postData(`/without-login/booking/step-2/${BookingData?.id}`, formData);
    if (response?.success) {
      // setTimeout(() => {
      await getBooking()
      await handleSave()
      // }, 2500);
    } else {
      // setApiError(response?.errors)
      console.error("Form submission failed:", response?.errors);
    }
  };

  const resetFormData = async () => {
    await reset({
      contact_no: BookingData?.user?.contact_no,
      email: BookingData?.user?.email || "",
      first_name: BookingData?.user?.first_name || "",
      last_name: BookingData?.user?.last_name || "",
    })
  }

  useEffect(() => {
    resetFormData()
  }, [BookingData]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="xl"
      className="edit_name_modal edit_trip_modal"
    >
      <Modal.Header>
        <Modal.Title>Edit Customer Details</Modal.Title>
        <div className="edit_close_btn" onClick={handleClose}>
          <FontAwesomeIcon icon={faXmark} style={{ color: "#FFFFFF" }} />
        </div>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Row>
            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter First Name"
                  {...register("first_name", {
                    required: "First name is required",
                    minLength: {
                      value: 3,
                      message: "First Name must be at least 3 characters",
                    },
                    maxLength: {
                      value: 50,
                      message: "First Name cannot exceed 50 characters",
                    },
                    pattern: {
                      value: /^[A-Za-z\s]+$/,
                      message: "First Name can only contain letters and spaces",
                    },
                  })}
                />
                {errors?.first_name && (
                  <span className="text-danger">
                    {errors.first_name.message}
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Last Name"
                  {...register("last_name", {
                    required: "Last name is required",
                    minLength: {
                      value: 3,
                      message: "Last Name must be at least 3 characters",
                    },
                    maxLength: {
                      value: 50,
                      message: "Last Name cannot exceed 50 characters",
                    },
                    pattern: {
                      value: /^[A-Za-z\s]+$/,
                      message: "Last Name can only contain letters and spaces",
                    },
                  })}
                />
                {errors?.last_name && (
                  <span className="text-danger">
                    {errors.last_name.message}
                  </span>
                )}
              </Form.Group>
            </Col>

            <Col md={6} className="mb-3">
              <Form.Group className="mb-3">
                <Form.Label>Contact Number</Form.Label>
                <Form.Control
                  placeholder="Contact Number"
                  type="text"
                  name="contact_no"
                  maxLength={10} // restrict typing to 10 digits
                  {...register("contact_no", {
                    required: "Contact Number is required",
                    pattern: {
                      value: /^[0-9]+$/,  // only numbers
                      message: "Only digits are allowed",
                    },
                    minLength: {
                      value: 10,
                      message: "Contact Number must be exactly 10 digits",
                    },
                    maxLength: {
                      value: 10,
                      message: "Contact Number must be exactly 10 digits",
                    },
                  })}
                />
                {errors?.contact_no && (
                  <span className="text-danger">
                    {errors.contact_no.message}
                  </span>
                )}
              </Form.Group>
            </Col>

            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label>Email Id</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter Email"
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
                      message: "Enter a valid email address",
                    },
                  })}
                />
                {errors?.email && (
                  <span className="text-danger">
                    {errors.email.message}
                  </span>
                )}
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <div className="both_btn_holder">
          <div onClick={handleClose}>
            <Prev_Btn text="Cancel" />
          </div>
          <div onClick={handleSubmit(onSubmit)}>
            <Next_Btn text="Save Changes" />
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default Edit_Name_Modal;
